export function getPreviousScreenId(store) {
  return store.form.lastScreen;
}
export function getCurrentScreen(store) {
  return store.screens.find((screen) => screen.id === store.form.currentScreen);
}
export function getScreenIdFromRoute(pathname) {
  return pathname.match(/.*.\/(\d+\.\d+)/)?.[1];
}
export function truncateScreenHistoryAfterId(store, screenId) {
  const history = store.form.screenHistory;

  const index = history.findIndex(
    (historyScreenId) => historyScreenId === screenId,
  );
  if (index === -1) return history;

  return history.slice(index);
}
export function getNextScreenIds(currentScreen) {
  return currentScreen?.logic?.map((screen) => screen.advanceToScreen);
}
// In case the user types a screen number or clicks the back/forward buttons
// Determine if we should set the screen value in the store to ensure proper calcuation on shouldUpdateScreen
export function shouldSetScreen(store, pathname) {
  const screenId = getScreenIdFromRoute(pathname);
  const currentScreen = getCurrentScreen(store);
  return currentScreen?.id !== screenId;
}
// Advance to next screen
export function getNextScreenId(store) {
  const currentScreen = getCurrentScreen(store);
  console.log("Current screen data:", { currentScreen });

  // Determine user's status based on store values
  const isAuthorizedUser = store.user.isAuthorized;

  // Specific navigation logic based on user status
  if (isAuthorizedUser) {
    return "2.9";
  }

  // Default navigation logic if no specific screen is determined
  for (const logic of currentScreen.logic) {
    for (const cond of logic.condition) {
      if (cond.type === "screen") {
        const conditionResponse = store.form.questions.find(
          (q) => String(q.questionId) === String(cond.referenceId), //TODO: check types of ids to remove cast
        );
        if (conditionResponse?.answerKey === cond.value) {
          return logic.advanceToScreen;
        }
      }
    }
  }

  // If no questions were found that matched the answer key
  return currentScreen.logic[0].advanceToScreen;
}
